module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/brave.a6afee5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/brave.jpg
// module id = 1Nho
// module chunks = 0